
define('app/auth/authMain',[
	'domReady',
	'app/auth/authApp',
	'app/common/setup',
	'unknown/unknownSetup'
], function(domReady, AuthApp, Setup, UnknownSetup){
	domReady(function () {
		Setup.initialize();
		AuthApp.initialize();
		UnknownSetup.initialize();
    });
});